import cn from 'classnames';
import React from 'react';

import FormattedPrice from 'components/basic/FormattedPrice';
import { H3 } from 'components/basic/Typography';
// import { borderColors } from 'components/basic/WithGradientBorder/constants';
import s from 'components/complex/payments/Product/Product.module.scss';

// import { plansColors } from 'components/complex/payments/Product/constants';
import type { ProductType } from 'redux-store/slices/products/types';

interface Props {
  product: ProductType;
  isShowDiscount: boolean;
  isCurrentUserPlan?: boolean;
}

export default function Price({
  product,
  isShowDiscount,
  isCurrentUserPlan,
}: Props): JSX.Element {
  const { price, currency, discount_price } = product.prices[0];
  const priceStyle = {};
  const showedPrice = isShowDiscount ? discount_price : price;
  const showedDiscountPrice = price;

  // if (isShowDiscount) {
  //   priceStyle = {
  //     ['--text-color']: borderColors[plansColors[interval]],
  //   } as React.CSSProperties;
  // }

  return (
    <div className={s.priceWrapper}>
      {isShowDiscount && (
        <H3 Tag="div">
          <FormattedPrice
            price={showedDiscountPrice}
            currency={currency}
            className={s.discountedPrice}
          />
        </H3>
      )}
      <H3 Tag="div">
        <FormattedPrice
          price={Number(showedPrice)}
          currency={currency}
          className={cn(s.price, {
            [s.currentPlanPrice]: isCurrentUserPlan,
          })}
          style={priceStyle}
        />
      </H3>
    </div>
  );
}
